module.exports = __webpack_public_path__ + "static/og-image-geotief-wien-6ec21695540dc432b448484928e0c91d.png";